import { MarketingEstimator } from "../estimator/MarketingEstimator";

export function Pricing({ onGetStarted }: { onGetStarted: () => void }) {
  return (
    <section className="section" id="pricing">
      <div className="container">
        <span className="eyebrow">Pricing</span>
        <h2 className="h-section" style={{ margin: "14px 0 6px", maxWidth: "24ch" }}>
          Done paying for Slack — per person, every month?
        </h2>
        <p className="lede" style={{ marginBottom: 32 }}>
          Slack bills you for every seat, forever. Slackcord is one payment: move
          your history to Discord and you’re done. Pay only for what you move —
          messages by the thousand, media by the gigabyte — and your first
          channel’s last 100 messages migrate free.
        </p>

        <MarketingEstimator onGetStarted={onGetStarted} />

        <AssessmentCta onGetStarted={onGetStarted} />

        <div className="rate-strip">
          <RateCard unit="1,000 messages" price="$15" note="first 1,000 included in the $100 base" />
          <RateCard unit="GB of pictures" price="$30" />
          <RateCard unit="GB of video" price="$75" />
          <RateCard unit="GB of files" price="$10" />
        </div>
      </div>
    </section>
  );
}

function AssessmentCta({ onGetStarted }: { onGetStarted: () => void }) {
  return (
    <div className="assessment card">
      <div className="assessment-copy">
        <span className="eyebrow">Free Slack Workspace Assessment</span>
        <p>
          The slider is a rough estimate. We’re onboarding teams in a private
          beta — join the waitlist and we’ll connect our bot, scan your
          workspace, and show your <b>exact</b> quote before you migrate a single
          message. No charge, no commitment.
        </p>
      </div>
      <button className="btn btn-primary" onClick={onGetStarted}>
        Join the waitlist for an exact quote
      </button>
    </div>
  );
}

function RateCard({ unit, price, note }: { unit: string; price: string; note?: string }) {
  return (
    <div className="rate-card">
      <span className="rate-price gradient-text">{price}</span>
      <span className="rate-unit">per {unit}</span>
      {note && <span className="rate-note mono">{note}</span>}
    </div>
  );
}
